import script from "./ShopTargetDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopTargetDialog.vue?vue&type=script&setup=true&lang=js"

import "./ShopTargetDialog.vue?vue&type=style&index=0&id=79416cdf&lang=css"
import "./ShopTargetDialog.vue?vue&type=style&index=1&id=79416cdf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79416cdf"]])

export default __exports__